export default ({...props}) => {
  const {palette} = props.theme
  return `
    &[ap_type="btn_spinner"]{
        color: ${palette.common.white};
    }
`
}
